// extracted by mini-css-extract-plugin
export default {"overlay":"OverlayLoader_overlay__cA573","img":"OverlayLoader_img__BU86R","img__rotate":"OverlayLoader_img__rotate__rTCJI","rot":"OverlayLoader_rot__80oL2"};